import { render } from "./About.vue?vue&type=template&id=923dcd0a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=923dcd0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-923dcd0a"

export default script